module.exports = __webpack_public_path__ + "static/media/ellipse.97688635.svg";